import Marquee from "react-fast-marquee";
import { Flame } from "lucide-react";

export default function MarqueeStrip({ items, dark = false }) {
  const parts = items.split("·").map((s) => s.trim()).filter(Boolean);
  return (
    <div
      data-testid="editorial-marquee"
      className={`border-y border-white/10 py-5 ${dark ? "bg-hell-black" : "bg-hell-coal"}`}
    >
      <Marquee speed={30} gradient={false} pauseOnHover>
        {parts.map((p, i) => (
          <span key={i} className="flex items-center gap-8 pr-8">
            <span className="font-cinzel text-lg md:text-2xl tracking-[0.2em] uppercase text-hell-bone/60 whitespace-nowrap">
              {p}
            </span>
            <Flame className="w-4 h-4 text-hell-ember shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
